/* Configurações de página */
export const PAGE_INDEX = 0
export const PAGE_SIZE = 20

/* Títulos */
export const TITTLE_WARNING = 'Tem certeza?'
export const TITTLE_NOTICE = 'Atenção!'

/* Mensagens de validação */
export const VALID_DATE = 'A data não pode ser maior que hoje!'
export const REQUIRED_FIELD = 'Campo obrigatório!'
export const CHAVE_ACESSO_INVALID =
  'A chave de acesso deve ter no máximo 44 caracteres'
export const CPF_CNPJ_INVALID = 'CPF/CNPJ inválido!'
export const CEP_INVALID = 'Cep inválido'
export const EMAIL_INVALID = 'E-mail inválido'
export const PASSWORDS_DO_NOT_MATCH_TRY_AGAIN =
  'As senhas não coincidem. Tente novamente.'
export const PLEASE_ADD_PRODUCT =
  'Insira pelo menos um produto para avançar a etapa'
export const PLEASE_FILL_IN_ALL_REQUIRED_FIELDS =
  'Preencha todos os campos obrigatórios!'

/* Mensagens de ação */
export const SAVE_REGISTRO = 'Registro salvo com sucesso'
export const UPDATE_REGISTRO = 'Registro atualizado com sucesso!'
export const FINISH_VENDA = 'Venda finalizada com sucesso!'
export const FINISH_ORCAMENTO = 'Orçamento finalizado com sucesso!'
export const FINISH_COMPRA = 'Compra finalizada com sucesso!'
export const EXPORT_ORCAMENTO =
  'Deseja converter este orçamento em venda? Após a conversão, a venda gerada não poderá ser editada.'
export const FINISH_COMPRA_WARNING =
  'Uma vez finalizada, esta compra não poderá ser editada novamente.'
export const FINISH_ORCAMENTO_WARNING =
  'Uma vez finalizado, você será redirecionado a listagem de orçamentos.'
export const FINISH_VENDA_WARNING =
  'Uma vez finalizada, esta venda não poderá ser editada novamente.'
export const UPDATE_REGISTRO_PRICE =
  'Uma vez atualizado, estes dados será atualizados permanentemente e não poderá ser recuperado.'
export const UPDATE_REGISTRO_SPC =
  'Ao confirmar, os dados de SPC serão atualizados de forma permanente. Esta ação não poderá ser revertida.'
export const UPDATE_REGISTRO_ALERTA =
  'Ao confirmar, os dados de alerta serão atualizados de forma permanente. Esta ação não poderá ser revertida.'
export const CANCELAR_REGISTRO =
  'Uma vez cancelado, este registro será cancelado permanentemente e não poderá ser recuperado.'
export const DELETE_REGISTRO =
  'Uma vez deletado, este registro será removido permanentemente e não poderá ser recuperado.'
export const ACTIVE_STATUS =
  'Uma vez ativado(a), este registro estará disponível no sistema e poderá ser pesquisado e utilizado.'
export const DISABLE_STATUS =
  'Uma vez desativado(a), este registro não poderá ser pesquisado ou utilizado no sistema até ser reativado(a).'

/* Mensagens de resposta */
export const RESP_UPDATE_STATUS = 'Status atualizado com sucesso!'

/* Mensagens de sucesso */
export const MESSAGE_DELETE_SUCCESS = 'Registro deletado com sucesso!'
export const MESSAGE_CANCEL_SUCCESS = 'Registro cancelado com sucesso!'
/* Mensagens de erro */
export const MESSAGE_ERROR_SERVIDOR = 'Erro no servidor!'

export const MESSAGE_WARNING_VALIDATION =
  'Preencha todos os campos obrigatórios!'
